export default "__VITE_ASSET__D3MzLP8k__"